import { render, staticRenderFns } from "./formTemplate.vue?vue&type=template&id=bf95c030&scoped=true"
import script from "./formTemplate.vue?vue&type=script&lang=js"
export * from "./formTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf95c030",
  null
  
)

export default component.exports